/* components/Header.svelte generated by Svelte v3.44.1 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import GithubIcon from './GithubIcon.svelte';
import ThemeSwitch from './ThemeSwitch.svelte';
import QuestionMarkIcon from './QuestionMarkIcon.svelte';

function create_fragment(ctx) {
	let header;
	let h1;
	let t1;
	let div;
	let themeswitch;
	let t2;
	let a;
	let questionmarkicon;
	let t3;
	let githubicon;
	let current;
	themeswitch = new ThemeSwitch({ props: { onChange } });
	questionmarkicon = new QuestionMarkIcon({});
	githubicon = new GithubIcon({});

	return {
		c() {
			header = element("header");
			h1 = element("h1");
			h1.textContent = "/GraphQL request parser/";
			t1 = space();
			div = element("div");
			create_component(themeswitch.$$.fragment);
			t2 = space();
			a = element("a");
			create_component(questionmarkicon.$$.fragment);
			t3 = space();
			create_component(githubicon.$$.fragment);
			attr(h1, "class", "svelte-5f5tme");
			attr(a, "href", "https://github.com/vladagurets/graphql-request-parser/blob/master/readme.md");
			attr(a, "class", "svelte-5f5tme");
			attr(div, "class", "right svelte-5f5tme");
			attr(header, "class", "svelte-5f5tme");
		},
		m(target, anchor) {
			insert(target, header, anchor);
			append(header, h1);
			append(header, t1);
			append(header, div);
			mount_component(themeswitch, div, null);
			append(div, t2);
			append(div, a);
			mount_component(questionmarkicon, a, null);
			append(div, t3);
			mount_component(githubicon, div, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(themeswitch.$$.fragment, local);
			transition_in(questionmarkicon.$$.fragment, local);
			transition_in(githubicon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(themeswitch.$$.fragment, local);
			transition_out(questionmarkicon.$$.fragment, local);
			transition_out(githubicon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(header);
			destroy_component(themeswitch);
			destroy_component(questionmarkicon);
			destroy_component(githubicon);
		}
	};
}

function onChange(params) {
	console.log(params);
}

class Header extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Header;